<template>
	<div>
		<div v-if="isUserAllowedInLevel1">
			<BaseHeader :title="companyType.title">
				<div class="flex items-center" v-if="$route.params.type === 'insurance'">
					<BaseButton class="btn-blue" @click="$router.push({ name: 'administrate_new_companies' })"
						>{{ companyType.buttonText }} {{ $t('add').toLowerCase() }}</BaseButton
					>
				</div>
			</BaseHeader>
			<div class="main">
				<BaseSelect v-model="filter" :filter-only="true" :options="filterOptions" class="w-56" label="Filter" @input="updateFilter" />

				<div v-if="companies && companies.length">
					<div class="text-lg mb-4 font-bold text-left" v-if="isInsurance && getCheckCompanies && getCheckCompanies.length">{{ $t('to_check') }}</div>
					<div class="flex flex-col mb-8" v-if="isInsurance && getCheckCompanies && getCheckCompanies.length">
						<div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
							<div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
								<div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
									<table class="min-w-full divide-y divide-gray-200">
										<thead>
											<tr>
												<th
													v-for="header in getHeader"
													:key="header.name"
													:class="header.class"
													class="py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
												>
													{{ header.name }}
												</th>
											</tr>
										</thead>
										<tbody class="bg-white divide-y divide-gray-200">
											<Fragment v-for="company in getCheckCompanies" :key="company.id">
												<CompanyRow
													:company-type="companyType"
													:is-insurance="isInsurance"
													:show-employees="company.showEmployees"
													:show-employees-icon="showEmployeesIcon"
													:show-enable-disable-icon="false"
													:value="company"
													@delete="updateCompanies"
													@toggleEmployees="toggleEmployees(company)"
												/>
											</Fragment>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>

					<div class="text-lg mb-4 font-bold text-left" v-if="isInsurance && getCheckCompanies && getCheckCompanies.length">
						{{ $t('insurances') }}
					</div>
					<div class="flex flex-col">
						<div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
							<div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
								<div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
									<table class="min-w-full divide-y divide-gray-200">
										<thead>
											<tr>
												<th
													v-for="header in getHeader"
													:key="header.name"
													:class="header.class"
													class="py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
												>
													{{ header.name }}
												</th>
											</tr>
										</thead>
										<tbody class="bg-white divide-y divide-gray-200" v-if="showCompanies">
											<Fragment v-for="company in getCompanies" :key="company.id">
												<CompanyRow
													:company-type="companyType"
													:is-insurance="isInsurance"
													:show-employees="company.showEmployees"
													:show-employees-icon="showEmployeesIcon"
													:value="company"
													@delete="updateCompanies"
													@toggleEmployees="toggleEmployees(company)"
												/>
											</Fragment>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else-if="!companies" class="flex flex-grow justify-center w-full opacity-75">
					<loader color="#343434" />
				</div>
				<div v-else>{{ $t('no_entries_found') }}</div>
			</div>
		</div>
		<div v-else>
			<Forbidden />
		</div>
	</div>
</template>

<script>
import loader from 'vue-spinner/src/PulseLoader.vue';
import BaseHeader from '@/components/navigation/BaseHeader';
import {
	CompanyApiFactory,
	DamageassessorscompanyApiFactory,
	InsurancesApiFactory,
	LawyerofficesApiFactory,
	RepairshopsApiFactory,
} from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import BaseButton from '@/components/forms/buttons/BaseButton';
import BaseSelect from '@/components/forms/inputs/BaseSelect';
import CompanyRow from '@/components/rows/CompanyRow';
import Forbidden from '@/views/default/Forbidden';
import Authentication from '@/mixins/Authentication';
import { Fragment } from 'vue-fragment';

export default {
	name: 'Companies',
	components: { Fragment, Forbidden, CompanyRow, BaseSelect, BaseButton, BaseHeader, loader },
	mixins: [Authentication],
	data() {
		return {
			showCompanies: true,
			companyType: {
				title: this.$t('companies'),
				buttonText: this.$t('company'),
			},
			companies: null,
			filterOptions: [
				{
					display: this.$t('active'),
					value: 'enabled',
				},
				{
					display: this.$t('disabled'),
					value: 'disabled',
				},
				{
					display: this.$t('all'),
					value: 'all',
				},
			],
			filter: {
				display: this.$t('active'),
				value: 'enabled',
			},
		};
	},
	created() {
		if (this.isUserAllowedInLevel1) {
			this.updateCompanies();
			this.setCompanyType();
		}
	},
	methods: {
		updateFilter() {
			this.showCompanies = false;
			this.$nextTick(() => {
				this.showCompanies = true;
			});
		},
		toggleEmployees(company) {
			this.$set(company, 'showEmployees', !company.showEmployees);

			if (!company.employees) {
				CompanyApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.companyIdEmployeesGet(company.company_id)
					.then(response => {
						this.$set(company, 'employees', response.data.data);
					});
			}
		},
		updateCompanies() {
			let promise;
			switch (this.$route.params.type) {
				case 'damageassessor':
					promise = DamageassessorscompanyApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios).damageassessorscompanyGet(1);
					break;
				case 'repairShop':
					promise = RepairshopsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios).repairshopsGet(0, 1);
					break;
				case 'car_dealership':
					promise = RepairshopsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios).repairshopsGet(1, 1);
					break;
				case 'lawyerOffice':
					promise = LawyerofficesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios).lawyerofficesGet(1);
					break;
				case 'insurance':
					promise = InsurancesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios).insurancesGet(1);
					break;
				case 'insuranceoffice':
					promise = InsurancesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios).insuranceofficesGet(1);
					break;
			}

			promise?.then(response => {
				this.companies = response.data?.data || response.data;
			});
		},
		setCompanyType() {
			switch (this.$route.params.type) {
				case 'damageassessor':
					this.companyType.title = this.companyType.buttonText = this.$t('damage_assessor');
					break;
				case 'repairShop':
					this.companyType.title = this.$t('repair_shops');
					this.companyType.buttonText = this.$t('repair_shop');
					break;
				case 'car_dealership':
					this.companyType.title = this.$t('car_shops');
					this.companyType.buttonText = this.$t('car_shop');
					break;
				case 'lawyerOffice':
					this.companyType.title = this.$t('lawyers_offices_lawyers');
					this.companyType.buttonText = this.$t('lawyers_office');
					break;
				case 'insurance':
					this.companyType.title = this.$t('insurances');
					this.companyType.buttonText = this.$t('insurance');
					break;
			}
		},
	},
	computed: {
		showEmployeesIcon() {
			return !this.isInsurance;
		},
		isRepairShopOrCarDealerShip() {
			return this.$route.params.type === 'car_dealership' || this.$route.params.type === 'repairShop';
		},
		isInsurance() {
			return this.$route.params.type === 'insurance';
		},
		getEnabledCompanies() {
			return this.companies.filter(company => company.is_enabled);
		},
		getDisabledCompanies() {
			return this.companies.filter(company => !company.is_enabled);
		},
		getCompanies() {
			let companies;
			switch (this.filter.value) {
				case 'enabled':
					companies = this.getEnabledCompanies;
					break;
				case 'disabled':
					companies = this.getDisabledCompanies;
					break;
				default:
					companies = this.companies;
					break;
			}

			if (this.isInsurance) {
				return companies.filter(company => company.is_system_insurance);
			}

			return companies;
		},
		getCheckCompanies() {
			return this.companies.filter(company => !company.is_system_insurance && !company.is_rejected);
		},
		getHeader() {
			const header = [];
			if (this.isInsurance) {
				header.push({ name: 'Name', class: 'px-6' });
				header.push({ name: 'Ort', class: 'px-6' });
				header.push({ name: 'E-Mail', class: 'px-6' });
			} else if (this.isRepairShopOrCarDealerShip) {
				header.push({ name: 'Name', class: 'px-6' });
				header.push({ name: 'Betriebsnummer', class: 'px-6' });
				header.push({ name: 'Aktiv seit', class: 'px-6' });
				header.push({ name: 'Inhaber', class: 'px-6' });
				header.push({ name: 'Autor', class: 'px-6' });
			} else {
				header.push({ name: 'Name', class: 'px-6' });
				header.push({ name: 'Zeit', class: 'px-6' });
				header.push({ name: 'Inhaber', class: 'px-6' });
				header.push({ name: 'Autor', class: 'px-6' });
			}

			return header;
		},
	},
	watch: {
		'$route.params.type'() {
			this.companies = null;
			this.updateCompanies();
			this.setCompanyType();
		},
	},
};
</script>
